import { concat, first, flatten, uniq, sortBy, last, cloneDeep } from "lodash"
import { addMinutes, getRoundHour, getTime } from "../../lib/utils"
import { DURATION_SLOT_MIN, ITEMS_PER_CAROUSEL_PAGE, PATH_DEEP } from "./models"
import { ACTION, Answer, Question, Reply, UiPosition } from "./types"

/*
 *
 */
export const get_complete_path = (pathId: string) => {
  const partial_path = pathId.split(":")

  let pathToIncrement = ""
  return partial_path.map((step: string, key: number) => {
    pathToIncrement += key ? `:${step}` : `${step}`
    return pathToIncrement
  })
}

export const replace_question = (questions: Question[], question: Question) => {
  return questions.map((_q) =>
    _q.id === (question as Question).id ? question : _q
  ) as Question[]
}
export const is_deep_path = (path: string) => path.includes(PATH_DEEP)

export const get_index_of_position = (
  position: UiPosition,
  itemsLength: number
) => {
  switch (position) {
    case "right":
      return itemsLength
    case "middle":
      return itemsLength / 2
    case "left":
    default:
      return 0
  }
}

export const split = (array: any[], nbElement: number) => {
  let chunk = []
  while (array.length > 0) chunk.push(array.splice(0, nbElement))
  return chunk
}

export const splitCarouselPages = (items: any[], nbElement: number) => {
  let chunk = []
  let array = cloneDeep(items)
  while (array.length > 0) chunk.push(array.splice(0, nbElement))
  return chunk
}

export const recursive_get = (question: Question, path: string[]): Question => {
  if (path.indexOf(question.id) === -1) return question
  else {
    path.splice(path.indexOf(question.id), 1)
    if (!path.length) return question
    else if (question.subquestion)
      return recursive_get(question.subquestion, path)
  }
  return question
}

/*
 * from replies, give the new part of the _path
 */
export const get_sub_path = (replies: Reply[], current: Question): string[] =>
  replies
    .map(({ action }: Reply) =>
      action === ACTION.subquestion && current.subquestion
        ? current.subquestion?.id
        : undefined
    )
    .filter((path: string | undefined) => path) as string[]

/*
 * update path question regarding the lasts replies
 */
export const update_path = (
  lastReplies: Reply[],
  actualPath: string[],
  current: Question
) => {
  const subPath: string[] = get_sub_path(lastReplies, current)

  const split_subPath = uniq(
    flatten(subPath.map((sub) => sub.split(PATH_DEEP)))
  )

  const path: any =
    actualPath.map((step) => {
      const parentOfSub = split_subPath
        .filter((v: string, key: number) => key < split_subPath.length - 1)
        .join(PATH_DEEP)

      if (step === parentOfSub) {
        return [step, ...subPath]
      }
      return [step]
    }) || actualPath
  return flatten(path)
}

export const update_answers = (answers: Answer[], fresh: Answer) => {
  let a = answers
  let toSet: Answer | undefined = a.find(
    ({ questionId }) => questionId === fresh.questionId
  )

  if (toSet !== undefined) {
    fresh.value = uniq(concat(toSet.value, fresh.value))
    a.splice(answers.indexOf(toSet), 1)
  }
  // Push fresh values
  a.push(fresh)
  return a
}

export const insertAt = (array: any[], index: number, ...elements: any) => {
  array.splice(index, 0, ...elements)
}

export const getSlotsReplies = (
  beforeSlots: number,
  afterSlots: number
): Reply[] => {
  let date: Date = getRoundHour()
  let passedDate = addMinutes(
    date,
    ITEMS_PER_CAROUSEL_PAGE * beforeSlots * -DURATION_SLOT_MIN
  )
  // CountSlots is the number of slots page
  // regarding the nb of items in a carousel page
  let countSlots: number = ITEMS_PER_CAROUSEL_PAGE * (afterSlots + beforeSlots)
  let replies: Reply[] = []
  for (let i = 0; i < countSlots; i++) {
    let minutesToAdd = i * DURATION_SLOT_MIN
    replies.push({
      title: getTime(addMinutes(passedDate, minutesToAdd)),
      value: addMinutes(passedDate, minutesToAdd).getTime(),
    })
  }
  return replies
}
